// Professional portfolio data - focused on core strengths

export const projects = [
  {
    id: 1,
    title: 'GAN-Powered Intrusion Detection System',
    subtitle: 'AI-Driven Cybersecurity Research',
    description: 'Advanced intrusion detection using Generative Adversarial Networks. Achieved 83.10% accuracy by generating synthetic attack data to balance imbalanced datasets.',
    fullDescription: 'Built a complete GAN framework (ACGAN + WCGAN) to enhance intrusion detection on NSL-KDD and UNSW-NB15 datasets. Reduced false negatives significantly by balancing class distribution through intelligent synthetic data generation.',
    technologies: ['Python', 'TensorFlow', 'Keras', 'ACGAN', 'WCGAN', 'Decision Tree', 'Scikit-learn'],
    githubUrl: 'https://github.com/Bharathyalagi/GAN-BASED-SYNTHETIC-DATA-GENERATION-IN-IDS',
    hasGithub: true,
    gradient: 'from-blue-500 to-cyan-500',
    impact: '83.10% test accuracy • Reduced false negatives • Published research'
  },
  {
    id: 2,
    title: 'Deep Learning Age & Gender Recognition',
    subtitle: 'Computer Vision with Transfer Learning',
    description: 'Production-ready facial analysis model using transfer learning on the Adience dataset. Optimized CNN architecture with extensive data augmentation.',
    fullDescription: 'Developed and deployed a deep learning model for real-time age and gender estimation. Implemented complete ML pipeline: data preprocessing, model training, evaluation, and visualization.',
    technologies: ['Python', 'TensorFlow', 'OpenCV', 'CNN', 'Transfer Learning', 'NumPy'],
    githubUrl: 'https://github.com/Bharathyalagi',
    hasGithub: true,
    gradient: 'from-cyan-500 to-blue-500',
    impact: 'Transfer Learning • Real-time inference • Production pipeline'
  },
  {
    id: 3,
    title: 'AI Fitness Coach - Pose Detection',
    subtitle: 'Real-Time Computer Vision Application',
    description: 'Intelligent fitness assistant using MediaPipe for real-time posture correction. Detects workout errors and provides instant feedback.',
    fullDescription: 'Engineered live body tracking system with 33 keypoint detection. Implemented error detection logic and intuitive OpenCV-based UI for hands-free monitoring.',
    technologies: ['Python', 'MediaPipe', 'OpenCV', 'NumPy', 'Computer Vision'],
    githubUrl: null,
    hasGithub: false,
    gradient: 'from-blue-600 to-cyan-400',
    impact: 'Real-time tracking • 33 keypoints • Hands-free UI'
  }
];

export const coreCompetencies = [
  {
    id: 1,
    title: 'Python Development',
    level: 'Expert',
    description: 'Primary language for AI/ML, data analysis, and backend development',
    icon: 'code',
    years: '3+'
  },
  {
    id: 2,
    title: 'SQL & Databases',
    level: 'Expert',
    description: 'Database design, optimization, and complex queries',
    icon: 'database',
    years: '3+'
  },
  {
    id: 3,
    title: 'Machine Learning',
    level: 'Advanced',
    description: 'Deep Learning, GANs, CNNs, Transfer Learning',
    icon: 'brain',
    years: '2+'
  }
];

export const skills = {
  'Core Languages': ['Python', 'SQL'],
  'ML/AI Frameworks': ['TensorFlow', 'Keras', 'Scikit-learn', 'OpenCV', 'MediaPipe'],
  'Databases': ['MySQL', 'PostgreSQL', 'MongoDB'],
  'Web Development': ['Django', 'React.js', 'Node.js', 'FastAPI'],
  'Tools & Platforms': ['Git', 'GitHub', 'Jira', 'VS Code', 'Jupyter', 'Firebase']
};

export const education = [
  {
    id: 1,
    degree: 'Master of Technology (M.Tech)',
    field: 'Computer Networks',
    institution: 'M. S. Ramaiah Institute of Technology',
    location: 'Bengaluru, India',
    period: 'Feb 2024 – Aug 2025',
    cgpa: '8.22',
    type: 'Masters',
    focus: 'Advanced networking, AI in cybersecurity, intrusion detection systems'
  },
  {
    id: 2,
    degree: 'Bachelor of Engineering (B.E.)',
    field: 'Computer Science',
    institution: 'AMC Engineering College',
    location: 'Karnataka, India',
    period: 'Aug 2019 – Jul 2023',
    cgpa: '7.78',
    type: 'Bachelors',
    focus: 'Core computer science, algorithms, data structures'
  }
];

export const experience = {
  company: 'Nivansys Technology',
  role: 'Software Developer Intern',
  period: '2024',
  location: 'Bengaluru, India',
  description: 'Full-stack development with Python/Django backend',
  responsibilities: [
    'Developed scalable backend systems using Python and Django framework',
    'Designed and optimized database schemas for enterprise applications',
    'Gained hands-on experience in complete software development lifecycle',
    'Collaborated with senior developers on production-grade projects'
  ],
  technologies: ['Python', 'Django', 'SQL', 'REST APIs']
};

export const certifications = [
  {
    id: 1,
    title: 'Full Stack Web Development',
    issuer: 'NICT Institute, Bengaluru',
    icon: 'award',
    description: 'MERN Stack (MongoDB, Express.js, React.js, Node.js)',
    year: '2024',
    status: 'Completed'
  }
];

export const personalInfo = {
  name: 'BHARATH YALAGI',
  tagline: 'AI/ML Engineer specializing in Deep Learning, Computer Vision & Cybersecurity',
  bio: 'M.Tech student with expertise in Python and SQL. Building intelligent systems that solve real-world problems using machine learning and deep learning.',
  email: 'bharathyalagi29738@gmail.com',
  phone: '+91 9611557513',
  location: 'Bengaluru, India',
  github: 'https://github.com/Bharathyalagi',
  linkedin: 'https://linkedin.com/in/bharathyalagi',
  currentStatus: 'M.Tech Student & AI/ML Developer',
  availability: 'Open to opportunities'
};